initialPrice